import { Heading, Stack, Separator } from '@chakra-ui/react';
import { SectionTitleBlock as ISectionTitleBlock } from '@/lib/types';
import BaseInputBlock from './base-input-block';

interface Props {
  block: ISectionTitleBlock;
}

export default function SectionTitleBlock({ block }: Props) {
  return (
    <BaseInputBlock block={block}>
      <Stack w='full' gap={0}>
        <Heading as='h3' fontSize='lg'>
          {block.field_name}
        </Heading>
        <Separator size='md' mx={-3} />
      </Stack>
    </BaseInputBlock>
  );
}
